import React, { useEffect, useState, useCallback } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts';
import axios from 'axios';
import { registerMap } from './registerMap';
import { countryCodeMap } from '../../utils/countryCodes';
import LogoSpinner from '../../Components/Common/LogoSpinner';

// Map of 2-letter to 3-letter country codes
/*const countryCodeMap = {
    'AF': 'AFG', 'AX': 'ALA', 'AL': 'ALB', 'DZ': 'DZA', 'AS': 'ASM', 'AD': 'AND', 'AO': 'AGO',
    'AI': 'AIA', 'AQ': 'ATA', 'AG': 'ATG', 'AR': 'ARG', 'AM': 'ARM', 'AW': 'ABW', 'AU': 'AUS',
    'AT': 'AUT', 'AZ': 'AZE', 'BS': 'BHS', 'BH': 'BHR', 'BD': 'BGD', 'BB': 'BRB', 'BY': 'BLR',
    'BE': 'BEL', 'BZ': 'BLZ', 'BJ': 'BEN', 'BM': 'BMU', 'BT': 'BTN', 'BO': 'BOL', 'BA': 'BIH',
    'BW': 'BWA', 'BV': 'BVT', 'BR': 'BRA', 'IO': 'IOT', 'BN': 'BRN', 'BG': 'BGR', 'BF': 'BFA',
    'BI': 'BDI', 'KH': 'KHM', 'CM': 'CMR', 'CA': 'CAN', 'CV': 'CPV', 'KY': 'CYM', 'CF': 'CAF',
    'TD': 'TCD', 'CL': 'CHL', 'CN': 'CHN', 'CX': 'CXR', 'CC': 'CCK', 'CO': 'COL', 'KM': 'COM',
    'CG': 'COG', 'CD': 'COD', 'CK': 'COK', 'CR': 'CRI', 'CI': 'CIV', 'HR': 'HRV', 'CU': 'CUB',
    'CY': 'CYP', 'CZ': 'CZE', 'DK': 'DNK', 'DJ': 'DJI', 'DM': 'DMA', 'DO': 'DOM', 'EC': 'ECU',
    'EG': 'EGY', 'SV': 'SLV', 'GQ': 'GNQ', 'ER': 'ERI', 'EE': 'EST', 'ET': 'ETH', 'FK': 'FLK',
    'FO': 'FRO', 'FJ': 'FJI', 'FI': 'FIN', 'FR': 'FRA', 'GF': 'GUF', 'PF': 'PYF', 'TF': 'ATF',
    'GA': 'GAB', 'GM': 'GMB', 'GE': 'GEO', 'DE': 'DEU', 'GH': 'GHA', 'GI': 'GIB', 'GR': 'GRC',
    'GL': 'GRL', 'GD': 'GRD', 'GP': 'GLP', 'GU': 'GUM', 'GT': 'GTM', 'GG': 'GGY', 'GN': 'GIN',
    'GW': 'GNB', 'GY': 'GUY', 'HT': 'HTI', 'HM': 'HMD', 'VA': 'VAT', 'HN': 'HND', 'HK': 'HKG',
    'HU': 'HUN', 'IS': 'ISL', 'IN': 'IND', 'ID': 'IDN', 'IR': 'IRN', 'IQ': 'IRQ', 'IE': 'IRL',
    'IM': 'IMN', 'IL': 'ISR', 'IT': 'ITA', 'JM': 'JAM', 'JP': 'JPN', 'JE': 'JEY', 'JO': 'JOR',
    'KZ': 'KAZ', 'KE': 'KEN', 'KI': 'KIR', 'KP': 'PRK', 'KR': 'KOR', 'KW': 'KWT', 'KG': 'KGZ',
    'LA': 'LAO', 'LV': 'LVA', 'LB': 'LBN', 'LS': 'LSO', 'LR': 'LBR', 'LY': 'LBY', 'LI': 'LIE',
    'LT': 'LTU', 'LU': 'LUX', 'MO': 'MAC', 'MK': 'MKD', 'MG': 'MDG', 'MW': 'MWI', 'MY': 'MYS',
    'MV': 'MDV', 'ML': 'MLI', 'MT': 'MLT', 'MH': 'MHL', 'MQ': 'MTQ', 'MR': 'MRT', 'MU': 'MUS',
    'YT': 'MYT', 'MX': 'MEX', 'FM': 'FSM', 'MD': 'MDA', 'MC': 'MCO', 'MN': 'MNG', 'ME': 'MNE',
    'MS': 'MSR', 'MA': 'MAR', 'MZ': 'MOZ', 'MM': 'MMR', 'NA': 'NAM', 'NR': 'NRU', 'NP': 'NPL',
    'NL': 'NLD', 'NC': 'NCL', 'NZ': 'NZL', 'NI': 'NIC', 'NE': 'NER', 'NG': 'NGA', 'NU': 'NIU',
    'NF': 'NFK', 'MP': 'MNP', 'NO': 'NOR', 'OM': 'OMN', 'PK': 'PAK', 'PW': 'PLW', 'PS': 'PSE',
    'PA': 'PAN', 'PG': 'PNG', 'PY': 'PRY', 'PE': 'PER', 'PH': 'PHL', 'PN': 'PCN', 'PL': 'POL',
    'PT': 'PRT', 'PR': 'PRI', 'QA': 'QAT', 'RE': 'REU', 'RO': 'ROU', 'RU': 'RUS', 'RW': 'RWA',
    'BL': 'BLM', 'SH': 'SHN', 'KN': 'KNA', 'LC': 'LCA', 'MF': 'MAF', 'PM': 'SPM', 'VC': 'VCT',
    'WS': 'WSM', 'SM': 'SMR', 'ST': 'STP', 'SA': 'SAU', 'SN': 'SEN', 'RS': 'SRB', 'SC': 'SYC',
    'SL': 'SLE', 'SG': 'SGP', 'SK': 'SVK', 'SI': 'SVN', 'SB': 'SLB', 'SO': 'SOM', 'ZA': 'ZAF',
    'GS': 'SGS', 'ES': 'ESP', 'LK': 'LKA', 'SD': 'SDN', 'SR': 'SUR', 'SJ': 'SJM', 'SZ': 'SWZ',
    'SE': 'SWE', 'CH': 'CHE', 'SY': 'SYR', 'TW': 'TWN', 'TJ': 'TJK', 'TZ': 'TZA', 'TH': 'THA',
    'TL': 'TLS', 'TG': 'TGO', 'TK': 'TKL', 'TO': 'TON', 'TT': 'TTO', 'TN': 'TUN', 'TR': 'TUR',
    'TM': 'TKM', 'TC': 'TCA', 'TV': 'TUV', 'UG': 'UGA', 'UA': 'UKR', 'AE': 'ARE', 'GB': 'GBR',
    'US': 'USA', 'UM': 'UMI', 'UY': 'URY', 'UZ': 'UZB', 'VU': 'VUT', 'VE': 'VEN', 'VN': 'VNM',
    'VG': 'VGB', 'VI': 'VIR', 'WF': 'WLF', 'EH': 'ESH', 'YE': 'YEM', 'ZM': 'ZMB', 'ZW': 'ZWE'
};*/

const GeographicDistribution = ({ dateRange }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [distributionData, setDistributionData] = useState([]);
    const [metadata, setMetadata] = useState(null);

    // Register the world map once on component mount
    useEffect(() => {
        registerMap(echarts);
    }, []);

    // Function to fetch data from API (as fallback)
    const fetchDataFromAPI = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const authToken = JSON.parse(sessionStorage.getItem('authUser'))?.token;
            if (!authToken) {
                throw new Error('Authentication token not found');
            }

            const apiUrl = `${process.env.REACT_APP_API_URL1}analytics/dashboard/geographic-distribution`;
            const response = await axios.get(apiUrl, {
                params: {
                    start_date: dateRange?.start?.toISOString(),
                    end_date: dateRange?.end?.toISOString()
                },
                headers: {
                    'Authorization': `${authToken}`
                }
            });

            if (response.data) {
                console.log('Geographic Distribution API Response:', response.data);
                
                // Transform the data to match the expected format
                const transformedData = response.data.distribution.map(item => ({
                    name: countryCodeMap[item.name] || item.name, // Convert to 3-letter code
                    value: item.value,
                    details: item.details
                }));
                
                console.log('Transformed Data:', transformedData);
                setDistributionData(transformedData);
                setMetadata(response.data.metadata);
            } else {
                console.warn('API returned unsuccessful response:', response.data);
                setError('Failed to fetch geographic distribution data. Please try again later.');
            }
        } catch (error) {
            console.error('Error fetching geographic distribution data:', error);
            setError(`Failed to fetch geographic distribution data: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    // Function to check and use WebSocket data if available
    const checkWebSocketData = () => {
        if (window.dashboardData && window.dashboardData.geographicDistribution) {
            console.log('Using WebSocket data for geographic distribution');
            const wsData = window.dashboardData.geographicDistribution;
            
            // Transform the data to match the expected format
            const transformedData = wsData.distribution.map(item => ({
                name: countryCodeMap[item.name] || item.name, // Convert to 3-letter code
                value: item.value,
                details: item.details
            }));
            
            console.log('Transformed WebSocket Data:', transformedData);
            setDistributionData(transformedData);
            setMetadata(wsData.metadata);
            setLoading(false);
            return true;
        }
        return false;
    };

    useEffect(() => {
        // First check if WebSocket data is available
        const hasWebSocketData = checkWebSocketData();
        
        // If no WebSocket data, fetch from API as fallback
        if (!hasWebSocketData) {
            fetchDataFromAPI();
        }
        
        // Set up event listener for WebSocket updates
        const handleGeographicDistributionUpdate = (data) => {
            console.log('Received geographic distribution update from WebSocket:', data);
            
            // Transform the data to match the expected format
            const transformedData = data.distribution.map(item => ({
                name: countryCodeMap[item.name] || item.name, // Convert to 3-letter code
                value: item.value,
                details: item.details
            }));
            
            setDistributionData(transformedData);
            setMetadata(data.metadata);
            setLoading(false);
        };
        
        // Add event listener
        if (window.dashboardEvents) {
            window.dashboardEvents.on('dashboard:geographicDistribution', handleGeographicDistributionUpdate);
        }
        
        // Clean up
        return () => {
            if (window.dashboardEvents) {
                window.dashboardEvents.off('dashboard:geographicDistribution', handleGeographicDistributionUpdate);
            }
        };
    }, [dateRange]);

    const getOption = () => {
        // Calculate max value safely using the value field
        const maxValue = distributionData.length > 0 
            ? Math.max(...distributionData.map(item => Number(item.value) || 0))
            : 100; // Default max if no data
        
        return {
            backgroundColor: '#fff',
            title: {
                text: metadata ? `Total Users: ${metadata.total_users.toLocaleString()}` : '',
                subtext: metadata ? `Across ${metadata.total_countries} Countries` : '',
                left: 'right',
                top: '10px',
                textStyle: {
                    fontSize: 14,
                    color: '#666'
                },
                subtextStyle: {
                    fontSize: 12,
                    color: '#999'
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    const countryData = distributionData.find(item => item.name === params.name);
                    if (countryData) {
                        return `
                            <strong>${params.name}</strong><br/>
                            Total Users: ${countryData.value.toLocaleString()}<br/>
                            Percentage: ${countryData.details.percentage.toFixed(2)}%<br/>
                            Active Users: ${countryData.details.active_users.toLocaleString()}<br/>
                            New Users (30d): ${countryData.details.new_users_30d.toLocaleString()}<br/>
                            Premium Users: ${countryData.details.premium_users.toLocaleString()}<br/>
                            Growth Rate: ${countryData.details.growth_rate.toFixed(1)}%
                        `;
                    }
                    return `${params.name}: No data`;
                }
            },
            visualMap: {
                min: 0,
                max: maxValue,
                text: ['High', 'Low'],
                realtime: false,
                calculable: true,
                inRange: {
                    color: ['#e6f7ff', '#1890ff']
                },
                outOfRange: {
                    color: ['#eee']
                }
            },
            series: [
                {
                    name: 'User Distribution',
                    type: 'map',
                    map: 'world',
                    roam: true,
                    emphasis: {
                        label: {
                            show: true
                        }
                    },
                    itemStyle: {
                        areaColor: '#eee',
                        borderColor: '#aaa'
                    },
                    scaleLimit: {
                        min: 1,
                        max: 5
                    },
                    data: distributionData
                }
            ]
        };
    };

    return (
        <Card style={{ height: "100%" }}>
            <CardHeader className="d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Geographic Distribution</h4>
            </CardHeader>
            <CardBody>
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                        <LogoSpinner message="Loading location data..." size="large" />
                    </div>
                ) : error ? (
                    <div className="text-center py-5 text-danger">
                        <i className="ri-error-warning-line fs-3 mb-3 d-block"></i>
                        {error}
                    </div>
                ) : (
                    <div id="geographic-map" style={{ height: '456px' }}>
                        <ReactECharts 
                            option={getOption()} 
                            style={{ height: '100%', width: '100%' }}
                            opts={{ renderer: 'canvas' }}
                        />
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default GeographicDistribution; 